<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iArfWx/tc-custom/9781429992862.jpg?1730579306425" alt="This image is the cover for the book Crown of Vengeance, The Dragon Prophecy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crown of Vengeance, The Dragon Prophecy
      </h1>
      <p class="bookDescription body article font2">
        <b>In this epic fantasy adventure series opener, a young elf, afraid of the magic inside her, becomes a fearsome warrior. </b><br/><br/>She is the unwanted spawn of a mad king and queen, her lands lost before her birth; her family—her very name—erased from history. Cursed by many, yet protected by an even great curse.<br/><br/>She was born on a night of storm and terror, raised in protected concealment, then banished from the only home she had ever known—an ancient enemy’s final stroke in a war begun centuries before.<br/><br/>Secret studies of hidden lore reveal the truth of the Prophecy that heralded her coming. Dark dreams teach lessons of war and duty, of strategy and Magecraft, that she could not learn in a thousand lifetimes.<br/><br/>She does not have a thousand lifetimes. She has just one—and time is running out. For the Prophecy spoke not just of her, but of a great Darkness that would destroy the Elven kingdoms. A Darkness that is coming ever closer.<br/><br/>She is Vieliessar Farcarinon and she must save her people. Even if she must shatter custom and destroy the world she was born to rule . . . <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mercedes Lackey, James Mallory
      </h2>
      
      <p class="authorDescription body article">MERCEDES LACKEY and JAMES MALLORY have written the Enduring Flame trilogy, which includes the <I>New York Times</I> bestseller <I>The Phoenix Transformed</I>, and the Obsidian Trilogy: <I>The Outstretched Shadow</I>, named Best Science Fiction, Fantasy, and Horror by <I>VOYA</I>; <I>To Light a Candle</I>, a <I>USA Today</I> bestseller; and <I>When Darkness Falls</I>, a <I>New York Times</I> bestseller.  Lackey lives in Claremore, Oklahoma. Mallory lives in Baltimore, Maryland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38ce104a